<template>
	<div class="language-wrap">
	<ul v-if="isFrench" :class="getLanguageClass">
		<li class="language__choice inactive"><button @click="changeLang" @mouseover="toggleHover" @mouseleave="toggleHover" @focus="toggleHover" @blur="toggleHover">EN</button></li>
		<li class="language__choice active"><span>FR</span></li>
	</ul>
	<ul v-else :class="getLanguageClass">
		<li class="language__choice active"><span>EN</span></li>
		<li class="language__choice inactive"><button @click="changeLang" @mouseover="toggleHover" @mouseleave="toggleHover" @focus="toggleHover" @blur="toggleHover">FR</button></li>
	</ul>
	</div>
</template>

<script>

	export default {

		data: function() {

			return {
				hover: false,
			}

		},

		computed: {

			getLanguage: function() {

				return window.appLang;

			},

			isFrench: function() {

				return (this.getLanguage === 'fr') ? true : false;

			},

			getLanguageClass: function() {

				var c = "language language--" + this.getLanguage;

				if ( this.$data.hover ) {
					c += ' js-invert';
				} 

				return c;

			}

		},

		methods: {

			changeLang: function() {

				if ( window.langSwitch ) {
					window.location = window.langSwitch + location.pathname;
				} else {
					alert('The language switcher is not available in Vue serve mode. Please run a build to test on the local development server.');
				}

			},

			toggleHover: function() {

				this.$data.hover = ! this.$data.hover;

			}

		}

	}
</script>

<style lang="scss">

$awidth: 30px;

.language {

	display: flex;
	flex-grow: 0;
	list-style-type: none;
	height: 36px;
	background: $red-dark;
	border: 3px solid $red-dark;
	border-radius: 20px;
	padding: 0;

	margin-left: 0;
	padding-left: 0;

	position: relative;

	&::before {

		border-sizing: border-box;
		content: '';
		display: block;
		position: absolute;
		left: 0px;
		top: 0px;
		height: $awidth;
		width: $awidth;
		background: $white;
		border-radius: 20px;
		z-index: 0;

		transition: left .3s ease;

		@include mq(tabdown) {

			background: $white;

		}

	}

	&.js-invert {

		//box-shadow: 0 0 2px 2px rgba($white, .85);
		box-shadow: 0 0 5px 1px rgba($black, .45);

		&::before {

			left: calc(100% - #{$awidth});

		}

		li.active {

			button, span {				

				color: $white;

				@include mq(tabdown) {

					color: $red;

				}

			}
			
		}

		button, span {

			color: $red;

			@include mq(tabdown) {

				color: $white;
				
			}

		}

	}

	&.language--fr {

		&::before {

			left: calc(100% - #{$awidth});

		}

		&.js-invert {

			&::before {

				left: 0;

			}
			
		}		

	}

	// @include mq(tabdown) {

	// 	position: absolute;
	// 	// top: calc(#{($logo-width) * $logo-ratio)} + 2rem);
	// 	left: 0;
	// 	box-shadow: 0 0 0 1px $white inset;

	// }

	@include mq(tab) {

		opacity: 1;
		visibility: visible;
		
	}	

	li {

		position: relative;
		z-index: 1;
		display: flex;
		align-items: center;
		// border: 1px solid white;

		&:first-child {

			button, span {
				// margin-right: -1px;
			}

		}

		&:last-child {

			button, span {

				// margin-left: -1px

			}

		}

		&.active {

			button, span {				

				color: $red;

			}

		}
		
	}

	button {

		cursor: pointer;
		
	}

	button, span {

		box-sizing: border-box;
		display: flex;
		appearance: none;
		background: none;
		line-height: 1em;
		padding: 0;
		margin: 0;

		justify-content: center;
		align-items: center;

		font-size: .75rem;
		height: $awidth;
		width: $awidth;
		border-radius: 20px;

		color: $white;
		outline: transparent;
		text-decoration: none;
		border: 2px solid transparent;

	}

}

.js-show-nav {

	.language {

		opacity: 1;
		visibility: visible;
		transition: opacity .7s ease, visibility .7s ease;

	}

}

</style>